import { i18n } from '../i18n';

import { buildLocalePath, DEFAULT_LOCALE, isSupportedLocale } from './localeConfig';

/**
 * Helper for non-hook contexts (e.g. window.location.href assignments).
 * Uses i18n.language as the locale source.
 *
 * Usage: window.location.href = localePath('/login');
 */
export const localePath = (path: string): string => {
  const locale = isSupportedLocale(i18n.language) ? i18n.language : DEFAULT_LOCALE;
  return buildLocalePath(path, locale);
};
